import { CallConsumptionChartWithFilters } from '@src/reducers/callConsumptionReport';
import type { RootState } from '@src/store/reduxstore';
import dayjs from 'dayjs';

export const getCallConsumptionSelectedDate = (state: RootState) =>
  state.adminHome.callConsumptionReport.filters.selectedDate;

export const getCallConsumptionSelectedDateFormated = (state: RootState) => {
  const { selectedDate } = state.adminHome.callConsumptionReport.filters;
  return [
    dayjs(selectedDate[0]).format('YYYY-MM-DD'),
    dayjs(selectedDate[1]).format('YYYY-MM-DD'),
  ];
};

export const getCallConsumptionFiltersGranularity = (state: RootState) =>
  state.adminHome.callConsumptionReport.filters.granularity;

export const getCallConsumptionChartFilters =
  (type: CallConsumptionChartWithFilters) => (state: RootState) =>
    state.adminHome.callConsumptionReport.filters.chartFilters[type];

export const getCallConsumptionSummary = (state: RootState) =>
  state.adminHome.callConsumptionReport.summary;

export const getCallConsumptionReportCostSeries = (state: RootState) =>
  state.adminHome.callConsumptionReport.costSeries;

export const getCallConsumptionReportCountSeries = (state: RootState) =>
  state.adminHome.callConsumptionReport.countSeries;

export const getCallConsumptionReportCountSeriesSummary = (state: RootState) =>
  state.adminHome.callConsumptionReport?.countSeries?.points?.reduce(
    (acc, point) => {
      if (point.incoming) {
        acc.incoming += point.incoming.count || 0;
        acc.total += point.incoming.count || 0;
      }
      if (point.outgoing) {
        acc.outgoing += point.outgoing.count || 0;
        acc.total += point.outgoing.count || 0;
      }

      return acc;
    },
    { incoming: 0, outgoing: 0, total: 0 }
  );

export const getCallConsumptionReportCountSeriesVisibility = (
  state: RootState
) => state.adminHome.callConsumptionReport.countSeriesBarsVisibility;

export default getCallConsumptionSelectedDate;
